import {AuctionType, PlanItemState, PlanState, ProductType} from "../utils/enums";
import {AddressItem} from "./newPlanItem";

export interface PlansFilterParams {
    year: number | null;
    state: PlanState | null;
}

export const filterInitialState : PlanFilterParams = {
    name: null,
    auctionType: null,
    itemType: null,
    state: null,
    auctionDate: null,
    productType: null,
}

export interface PlanFilterParams {
    name: string | null;
    auctionType: AuctionType | null;
    itemType: string | null;
    state: PlanItemState |  null;
    auctionDate: Date | null;
    productType: ProductType | null;
}

// Интерфейс функции
export type SearchFunction<T> =
    (filters: T) => void;

export type Plan = {
    id: number;
    state: PlanState;
    year: number;
    createdAt: string;
    approvedAt: string | null;
}

export type PlanList = Plan & {
    itemCount: number;
    gross: number;
}

export type PlanItem = {
    id: number
    price: number
    amount: number
    planNo: string
    productType: ProductType
    auctionType: AuctionType
    // item: RubricItem & { productName: string }
    addresses: AddressItem[] & { region: string }
    auctionDate: Date | null
    deliveryDate: Date | null
    productCode: string;
    productName: string;
    productBrief: string;
    unit: {id: number | null, label: string} | null;
    state: PlanItemState
}

export type PlanItemList = {
    id: number
    productCode: string
    productName: string
    productBrief: string
    productType: ProductType
    amount: number
    price: number
    auctionType: AuctionType
    state: PlanState
    gross: number
    auctionDate: string
    unitName: string
    createdAt: string
}